import React from 'react';
import Hero from './Hero';
import CapabilityCards from './CapabilityCards';
import ProcessSteps from './ProcessSteps';
import ServicesOverview from './ServicesOverview';
import WhyChooseUs from './WhyChooseUs';
import Industries from './Industries';
import CTASection from './CTASection';

const HomePage = () => {
  return (
    <div>
      <Hero />
      <CapabilityCards />
      <ProcessSteps />
      <ServicesOverview />
      <WhyChooseUs />
      <Industries />
      <CTASection />
    </div>
  );
};

export default HomePage;